<div class="layout-row full gap-xs">
  <div class="flex-none layout-col place-center-center day-name">
    <div class="layout-col place-center-center" style="min-width: 50px; padding: 8px">
      <span class="mat-body-strong">{{ name }}</span>
    </div>
  </div>

  @if (this.timeSlots$ | async; as timeSlots) {
    <div class="flex layout-row gap-xs day-content">
      <!-- todo: fix dir.valueAccessor null error on click-->
      @for (slot of timeSlots; track slot) {
        <app-time-schedule-slot [timeSchedule]="slot" (click)="editTimeSlot(slot)">
        </app-time-schedule-slot>
      }
      <span class="flex"></span>
      <div class="layout-col place-center-center">
        <button mat-icon-button (click)="addTimeSlot($event)">
          <mat-icon>add</mat-icon>
        </button>
      </div>
    </div>
  }
</div>
